import React from 'react';
import { Link } from 'gatsby';
import { motion } from "framer-motion";

export function DesktopNav({ navLinks, hovered, setHovered, isCurrent }) {
  return (
    <nav
      onMouseLeave={() => setHovered(null)}
      className="hidden md:flex items-center gap-10"
    >
      {navLinks.map((link, index) => (
        <React.Fragment key={link.title}>
          <Link
            to={link.route}
            className="relative text-xl text-gray-300 hover:text-white transition-colors duration-300 ease-out group"
            onMouseEnter={() => setHovered(link.route)}
          >
            {link.title}

            {(hovered === link.route || isCurrent(link.route)) && (
              <motion.span
                layoutId="nav-underline"
                className="absolute left-0 -bottom-1 h-[2px] w-full bg-white"
                transition={{
                  type: "spring",
                  stiffness: 500,
                  damping: 35,
                }}
              />
            )}
          </Link>

          {navLinks.length - 1 !== index && (
            <span className="text-white/30">|</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}